export default __webpack_public_path__ + "static/media/logo_hrl_res.d738bcb6.png";